import { CatalogServiceBase } from './catalog-service';
export class PrivateCatalogService extends CatalogServiceBase {
    constructor(httpClient, baseUrl) {
        super(httpClient, baseUrl, '/api/v2');
    }
}
//# sourceMappingURL=private-catalog-service.js.map